$(function() {
	$('#devicesCheckAll').on('click', function() {
		var check = $(this).is(':checked');

		$('tbody', '#grid-devices').find('input:checkbox').each(function() {
			$(this).attr('checked', check);
		})
	});

	$('.devicesProcessAll', '#usedcars').on('click', function(e) {
		e.preventDefault();

		var devices = [];

		$('tbody', '#grid-devices').find('input:checkbox:checked').each(function() {
			devices.push($(this).data('id'));
		});

		if (devices.length) {
			$.ajax({
				url: '/_/moya/usedcars/device/special',
				method: 'post',
				data: {
					devices: devices,
					special: $('#overlayAdverts').val(),
					middleBanner: $('#middleBanners').val(),
					warrantyAdvert: $('#warrantyAdvert').val(),
				}
			}).done(function(response) {
				location.reload();
			}).error(function(response) {
				moya.message.growl('Villa við að vista', 'error');
			});
		}
	})
});
